import * as React from "react";
import {APIClient} from "../../../utils/APIClient";
import {Spinner} from "../../Spinner";


export class AuthUrlLinkBase extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };

        this.redirectToAuthPage = this.redirectToAuthPage.bind(this);
        this.deleteAgencyConnection = this.deleteAgencyConnection.bind(this);
    }

    redirectToAuthPage(){
        throw new Error("Method not implemented.");
    }

    _getAuthURL(){
        throw new Error("Method not implemented.");
    }

    _getDeleteUrl(){
        throw new Error("Method not implemented.");
    }

    deleteAgencyConnection() {
        this.setState({
            loading: true
        });

        const url = this._getDeleteUrl();

        new APIClient(url).call('POST')
            .then((response) => {
                this.setState({
                    loading: false
                });

                if (response.status === 'NO_MODULE_ACCESS' || response.status === 'ERROR') {
                    alert(response['error_message']);
                } else if (response.status === 'OK') {
                    this.props.onConnectionDeleted()
                }
            }).catch((error) => {alert(error)})
    }

    renderConnectionButton(){
        throw new Error("Method not implemented.");
    }

    renderDisconnectButton(){
        throw new Error("Method not implemented.");
    }

    render() {
        if (this.props.hasConnection === false) {
            return this.renderConnectionButton()
        } else {
            if (this.state.loading) {
                return (
                    <button className="btn">
                        <Spinner color="positive small"/>
                    </button>
                );
            }

            return this.renderDisconnectButton()
        }
    }
}
